import React from 'react'
import {observer} from 'mobx-react-lite'
import {useBasketStore} from '../../../store/hooks/useStore'
import { PromoThresholdProgressBar } from './promo-threshold-progress-bar'

interface OrderSummaryProgressBarsProps {
  border: boolean
}

export const OrderSummaryProgressBars = observer(({border}: OrderSummaryProgressBarsProps) => {
  const {basket: order, filteredPromotionalThresholds, currentDeliverySlotId} = useBasketStore()
  const customerHasBookedSlot = Boolean(currentDeliverySlotId)

  return (
    <>
      {order ? filteredPromotionalThresholds.map((thresholdItem) => {
        const isMinDeliveryThreshold = thresholdItem.thresholdSource === 'minDelivery'
        if (isMinDeliveryThreshold || customerHasBookedSlot) {
          return (
            <PromoThresholdProgressBar
              promoThreshold={thresholdItem}
              currency={order.currency as string}
              border={border}
            />
          )
        }
      }) : null}
    </>
  )
})
